import React from 'react'
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material'
import { MAX_FARMS, MEMORY_WARNING } from '../../utils/localReset/farmSelection'
import { contagem } from '../../utils/localReset/messages'

export default function FarmSelectionScreen({
  farms,
  selected,
  notice,
  onToggle,
  onConfirm,
}) {
  const full = selected.length >= MAX_FARMS
  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', p: 3, width: '100%' }}>
      <Typography variant='h5' sx={{ mb: 1 }}>
        Quais fazendas você quer baixar de novo?
      </Typography>
      <Alert severity='warning' sx={{ mb: 2 }}>
        {MEMORY_WARNING}
      </Alert>
      {notice && (
        <Alert severity='info' sx={{ mb: 2 }}>
          {notice}
        </Alert>
      )}
      <Typography variant='body2' sx={{ mb: 1 }}>
        Selecionadas: {selected.length} de {MAX_FARMS}
      </Typography>
      <Box sx={{ maxHeight: '45vh', overflow: 'auto', mb: 2 }}>
        {farms.map((f) => {
          const checked = selected.includes(f.id)
          return (
            <FormControlLabel
              key={f.id}
              sx={{ display: 'flex' }}
              control={
                <Checkbox
                  checked={checked}
                  disabled={full && !checked}
                  onChange={() => onToggle(f.id)}
                />
              }
              label={f.nome}
            />
          )
        })}
      </Box>
      <Button variant='contained' onClick={onConfirm}>
        {selected.length > 0
          ? `Baixar ${contagem(selected.length, 'fazenda', 'fazendas')}`
          : 'Concluir sem baixar fazendas'}
      </Button>
    </Box>
  )
}
